import {useState} from "react"
import {useNavigate} from "react-router-dom"
import axios from "axios"
import Spinner from "react-bootstrap/Spinner";

export default function Changepassword() {
  const nav = useNavigate()
  const [isLoading, setIsLoading] = useState(false);

  const [form, setForm] = useState({username: "", password: "", passwordConfirm: "", awairToken: ""})

  const onFormChange = (e) => {
    // form.username = user.username
    setForm({...form, [e.target.name]: e.target.value})
  }

  if (isLoading) return (
    <div id="overlay">
      <p className="my-3 fs-3 fw-bolder">Processing</p>
      <Spinner animation="border" variant="success" role="status"></Spinner>
    </div>
  )

  const submit = async (e) => {
    e.preventDefault()
    setIsLoading(true);
    // const headers = {Authorization: `Bearer ${user.token}`}
    await axios.post('/api/users/resetpass', form)
      .then(response => {
        console.log(response)
        setIsLoading(false);
        alert("Password changed successfully.\n\nIMPORTANT:\nClose your app, delete the Settings.ini file and open the app again to reconfigure your device with your new password.\n\nAlso don't forget to log in and connect your wallet again.")        
        // alert("Password changed successfully")
        nav("/members");
      }).catch(error => {
        console.log(error);
        alert(error.response.data.message);
      });

  }

  return (    
    <div className="row text-white pt-5">
      <div className="col-12 col-lg-6 mx-auto">
        <form onSubmit={submit} className="mx-auto">
          <h2 className="mb-4 text-center">Change password</h2>
          <p className="small">Awair Token is used only for verification and will never be stored on Element Data's server.</p>

          <div className="row gy-4">
            <div className="col-12">
              <label className="form-label">Awair Token</label>
              <input
                onChange={onFormChange}
                value={form.awairToken}
                name="awairToken"
                type="text"
                className="form-control"
                placeholder="Enter your Awair token"
                required
              />
            </div>

            <div className="col-12">
              <label className="form-label">Device ID</label>
              <input
                onChange={onFormChange}
                value={form.username}
                name="username"
                type="text"
                className="form-control"
                placeholder="awair-element_12345"
                required
              />
            </div>

            <div className="col-12">
              <label className="form-label">Password</label>
              <input
                onChange={onFormChange}
                value={form.password}
                name="password"
                type="password"
                className="form-control"
                placeholder="Enter new password"
                required
              />
            </div>

            <div className="col-12">
              <label className="form-label">Confirm Password</label>
              <input
                onChange={onFormChange}
                value={form.passwordConfirm}
                name="passwordConfirm"
                type="password"
                className="form-control"
                placeholder="Confirm new password"
                required
              />
            </div>
          </div>
          <button disabled={isLoading} type="submit" className="w-100 btn btn-success mt-5">
            Change password
          </button>
        </form>
      </div>
    </div>
  )
}
